import { createStyles } from "@mantine/core"

export const useStyles = createStyles((theme) => ({
    button: {
        [theme.fn.smallerThan("xs")]: {
            flex: 1,
        },
    },
}))
